import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const read = (realm) => {
  try {
    return { ...realm.defaults, ...JSON.parse(sessionStorage.getItem(realm.storageKey) || '{}') };
  } catch {
    return realm.defaults;
  }
};

const valid = (list, id) => list.some((x) => x.id === id);

export const useArtifactConfig = (realm) => {
  const [params, setParams] = useSearchParams();
  const [config, setConfig] = useState(() => {
    const base = read(realm);
    const stone = params.get('stone');
    const metal = params.get('metal');
    return {
      stone: valid(realm.stones, stone) ? stone : base.stone,
      metal: valid(realm.metals, metal) ? metal : base.metal,
    };
  });

  useEffect(() => {
    sessionStorage.setItem(realm.storageKey, JSON.stringify(config));
    setParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set('stone', config.stone);
      next.set('metal', config.metal);
      return next.toString() === prev.toString() ? prev : next;
    }, { replace: true });
  }, [config, realm.storageKey, setParams]);

  const stone = realm.stones.find((s) => s.id === config.stone) || realm.stones[0];
  const isEx = Boolean(stone.ex);
  return {
    metal: config.metal,
    stone: stone.id,
    isEx,
    edition: isEx ? 'ex' : 'original',
    setMetal: (metal) => setConfig((c) => ({ ...c, metal })),
    setStone: (id) => setConfig((c) => ({ ...c, stone: id })),
    setEdition: (edition) => {
      const target = realm.stones.find((s) => Boolean(s.ex) === (edition === 'ex')) || realm.stones[0];
      setConfig((c) => ({ ...c, stone: target.id }));
    },
  };
};
